import { RetailCartValue } from "@/dto/retailCartValue";
import { ScanToOrderCartItemRight } from "./scanToOrderCartItemRight";
import { ScanToOrderCartItemLeft } from "./scanToOrderCartItemLeft";
import { useRouter } from "next13-progressbar";
import { getFromLocalStorage } from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { buildScanToOrderSearchParams } from "@/utils/scanToOrderUtils";
import { ScanToOrderInfo } from "@/dto/scanToOrderInfo";

export interface ScanToOrderCartItemProps {
  item: RetailCartValue;
  index: number;
  removeFromCart?: (event: React.MouseEvent, index: number) => void;
  onRequestClose: () => void;
}
export const ScanToOrderCartItem = ({
  item,
  index,
  removeFromCart,
  onRequestClose,
}: ScanToOrderCartItemProps) => {
  const router = useRouter();
  const scanToOrderInfo = getFromLocalStorage<ScanToOrderInfo | null>(
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    null
  );
  const handleItemClick = () => {
    let queryParams = "";
    if (scanToOrderInfo) {
      queryParams = buildScanToOrderSearchParams(scanToOrderInfo);
    }
    router.push(`/menu/${item.id}` + queryParams);
    onRequestClose();
  };
  return (
    <div
      key={index}
      className="flex flex-col justify-between items-center py-4 border-b cursor-pointer"
      onClick={() => handleItemClick()}
    >
      <div className="w-full flex flex-row justify-between">
        <ScanToOrderCartItemLeft
          name={item?.name}
          quantity={item?.quantity}
          isAgeRestricted={item?.isAgeRestricted}
          modifiers={item?.modifiers}
          specialInstructions={item.specialInstructions}
        />
        <ScanToOrderCartItemRight
          index={index}
          price={item?.price}
          removeFromCart={removeFromCart}
        />
      </div>
    </div>
  );
};
